



























































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import UpdateServiceDialog from "../../components/admin/UpdateServiceDialog.vue";
import DeleteServiceDialog from "../../components/admin/DeleteServiceDialog.vue";
import { Service as ServiceInterface } from "../../services/service/entities/service.interface";
import privileges from "../../utils/privileges";
import constants from "../../config/constants";

@Component({
  components: {
    UpdateServiceDialog,
    DeleteServiceDialog
  }
})
export default class SingleService extends Vue {
  @Prop() service!: ServiceInterface;
  @Prop() totalServices!: number;
  @Prop() page!: number;

  dialogUpdate = false;
  dialogDelete = false;
  loadingDelete = false;
  componentKey = 1;
  privilegeName = constants.PRIVILEGE_NAME;
  privilegeType = constants.PRIVILEGE_TYPE;

  private checkPrivilege(name: string, type: string): boolean {
    return privileges.checkPrivilege(name, type);
  }

  private openDialogUpdate(): void {
    this.dialogUpdate = true;
    this.componentKey++;
  }

  private openSuccessSnackbar(): void {
    this.$emit("openSuccessSnackbar");
  }

  private openErrorSnackbar(): void {
    this.$emit("openErrorSnackbar");
  }
}
